import React from 'react';
import HeroSection from '../components/HeroSection';
import HowItWorksSection from '../components/HowItWorksSection';
import FeaturedTemplesSection from '../components/FeaturedTemplesSection';
import CtaSection from '../components/CtaSection';
import FAQSection from '../components/FAQSection';
import PageTransition from '../components/PageTransition';

function HomePage() {
  return (
    // This <main> tag holds all the sections of your page
    <main className="flex-grow">
      <HeroSection />

      <FeaturedTemplesSection />
      <HowItWorksSection />
      <CtaSection />
      <FAQSection />
    </main>
  );
}

export default PageTransition(HomePage);
